export enum Shadow {
  _100 = '0 0 20px 0 rgba(0,0,0,0.05)',
  _300 = '0px 4px 20px rgba(0, 0, 0, 0.12)',
  _500 = '0 2px 10px 0 rgba(0,0,0,0.33)',
  _600 = '0px 10px 20px rgba(0, 0, 0, 0.06)',
  _1000 = `
        0px 11px 15px -7px rgba(0, 0, 0, 0),
        0px 24px 38px 3px rgba(0, 0, 0, 0),
        0px 9px 46px 8px rgba(0, 0, 0, 0.04)
      `,
}

export enum primary {
  main = '#004B54',
  light = '#00BAD1',
  dark = '#002E33',
  contrastText = '#fff',
}

export enum secondary {
  main = '#FFE33D',
  light = '#FFEB70',
  lighter = '#FFF9D6',
  dark = '#FFD105',
  contrastText = '#004B54',
}

export enum neutrals {
  main = '#61646B',
  light = '#9DB2B5',
  lighter = '#D3D4D6',
  dark = '#2F3034',
  contrastText = '#F7F8FA',
}

export enum error {
  main = '#D12D15',
  dark = '#A12310',
  light = '#F8C2B9',
}

export enum success {
  main = '#075F30',
  light = '#09763C',
  lighter = '#CAE5D9',
}

export enum warning {
  main = '#FC8941',
  light = '#FFCFB1',
}

export enum info {
  main = '#2F1FDE',
  light = '#594CE6',
}

export enum common {
  white = '#FFFFFF',
}
